<template>
	<div
		v-bind="$attrs"
		class="mlc-hero"
	>
		<slot />
	</div>
</template>

<script src="./mlc-hero.js" />
